import { DataTable } from "./data-table";
import type { DataTableItem, DataTableProps } from "./shared";

type SubDataTableProps<T extends DataTableItem> = Pick<
	DataTableProps<T>,
	"data" | "columns" | "persistenceKey"
> &
	Partial<
		Pick<
			DataTableProps<T>,
			"isLoading" | "refetch" | "queryKey" | "menu" | "getRowCanExpand" | "renderSubRows"
		>
	>;

export function SubDataTable<T extends DataTableItem>({
	isLoading = false,
	refetch = async () => {},
	queryKey = [],
	menu = null,
	...props
}: SubDataTableProps<T>) {
	return (
		<DataTable
			variant="sub-table"
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			menu={menu}
			{...props}
		/>
	);
}
